export default __webpack_public_path__ + "static/media/tabuleiro-desfocado.ca0d1401.webp";